import { render } from "./AppIcon.vue?vue&type=template&id=531a40f2"
import script from "./AppIcon.vue?vue&type=script&lang=js"
export * from "./AppIcon.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\jimoty\\JimotyWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__